import { render } from "./AssetOwners.vue?vue&type=template&id=cc6881e6"
import script from "./AssetOwners.vue?vue&type=script&lang=js"
export * from "./AssetOwners.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__